/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  h5ToApp.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:26
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/* h5对接原生 */
import Bridge from '@/utils/bridge'
import { FeiDaiUserDetails, SysMenuDTO } from '@/api/sys-auth'
import { Toast } from 'vant'

export class AppUserInfoDto {
  token?: string
  mobile?: string
  userInfo?: FeiDaiUserDetails
  menus?: SysMenuDTO[]
}

export class DownFilePrams {
  filePath?: string
  fileName?: string
}

export class LoginReturnDataDto {
  /* token */
  access_token?: string
  /* Token类型 */
  token_type?: string
  refresh_token?: string
  expires_in?: number
  userId?: string
  /* 是否是使用二级账号登录  */
  islogin?:string
  /* 前端通过userType为1识别一级账户，为2识别二级账户。 */
  userType?: string
  /* 是否绑定手机号 前端通过userType为2识别二级账户，再取该字段值。 */
  isBindMobile?: string
  /* 账户下公司数量 前端通过userType为1识别一级账户，再取该字段值。 */
  tenantCount?: string
  /* 登录手机号 */
  mobile?: string
  /* 登录密码 */
  password?: string
  /* 登录密码 */
  companyId?: string
  /* 当前版本 二级账号时 */
  currentVersionCode?: string
  /* 当前版本(从选择公司进去时) */
  currentVersion?: string
  /* 合作方邀请码 */
  versionCode?: string
  /* 企业是否实名 */
  isIdentification?: string
  /* 是否过期 */
  isExpiration?: string
  /* 到期时间 */
  expirationTime?: string
  /* 距离到期天数 */
  trial?: string
  /* 合作方id */
  partnerCompanyId?: string
}

/**
 * 从原生获取用户登录信息
 */
export function getUserInfoFromApp () {
  return new Promise((resolve, reject) => {
    // 登录接口返回数据
    // setTimeout(() => {
    //     const res = {
    //         access_token: "74d30892-5fde-4b36-90cf-bd86d0eea728",
    //         token_type: "bearer",
    //         refresh_token: "9e496411-e94f-43c0-872b-83095b61a555",
    //         expires_in: 43017,
    //         scope: "all",
    //         userId: "61979cefd5e8c875022a08b3",
    //         userType: "1",
    //         isBindMobile: "0",
    //         tenantCount: 1,
    //         mobile: "17734820636"
    //     }
    //     resolve(res)
    // })
    let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    let flag = false
    Bridge.callHandler('getUserInfo', {}, (res: string, ) => {
      flag = true
      res = !res ? {} : JSON.parse(res)
      console.log('%ch5ToApp.ts line:93 getUserInfoFromApp', 'color: #007acc;');
      resolve(res)
    })
    if(isiOS) {
      setTimeout(() => {
        if(flag === false) {
          console.log('%ch5ToApp.ts line:100 setTimeout', 'color: #007acc;', 'if');
          // resolve('')
          Bridge.callHandler('logout', {msg:''})
        }else {
          console.log('%ch5ToApp.ts line:102 setTimeout', 'color: #007acc;', 'else');
        }
      },1500)
    }
  })
}

/**
 * 调用原生返回上一页
 */
export function backToBefore () {
  Bridge.callHandler('backToBefore', {})
}

/**
 * 调用原生跳转到供应商
 */
export function toCustomerManage () {
  Bridge.callHandler('toCustomerManage', {})
}

/**
 * 调用原生跳转到采购单
 */
export function toOrderReturn () {
  Bridge.callHandler('toOrderReturn', {})
}

/**
 * 调用原生跳转到采购单订单详情
 */
export function toOrderReturnDetail () {
  Bridge.callHandler('toOrderReturnDetail', {})
}

/**
 * 调用原生跳转到企业商城
 */
export function toShopView () {
  Bridge.callHandler('toShopView', {})
}

/**
 * 调用原生方法拨打电话
 */
export function callPhone (data: { tel?: string }) {
  Bridge.callHandler('callPhone', data)
}

/**
 * 调用原生方法跳转到银行账户信息选择页面
 */
export function toAccountManage () {
  Bridge.callHandler('toAccountManage', {})
}

/**
 * js调用原生api跳转二维码扫描页面方法
 */
export function toQRCodePage () {
  Bridge.callHandler('toQRCodePage', {})
}

/**
 * js调用原生api下载文件到文件方法
 参数：{
        "filePath":"", //文件路径
        "fileName":"" //文件名
    }
 */
export function downFileToSystemFile (data: DownFilePrams) {
  Bridge.callHandler('downFileToSystemFile', data)
}

/**
 * js调用原生api打开账号设置页面
 * @param data  {“userType”:  “用户类型”}
 */
export function toAccountSetting (data: LoginReturnDataDto) {
  Bridge.callHandler('toAccountSetting', data)
}

/**
 * js调用原生api打开消息中心页面
 */
export function goToMessage () {
  Bridge.callHandler('goToMessage', {})
}

/**
 * js调用原生api分享
 * @param data  {“title”:  “标题”，“description”:  “描述”，“url”:   “链接”，}
 */
export function shareToWeiXin (data: { title?: string; description?: string; url?: string }) {
  Bridge.callHandler('shareToWeixin', data)
}

/**
 * js调用原生打开新页面
 * @param data  {“url”: } 页面地址 firstPageRouter 首页的路由名称（原生通过此数据判断返回键是否直接返回至产业科技app）
 */
export function openNewPage (data: { url?: string; firstPageRouter?: string[] }) {
  data.firstPageRouter = ['/home', '/quotaTest', '/quotaTestReview','/loginCYKJ','/registerCYKJ']
  Bridge.callHandler('openNewPage', data)
}

/**
 * js调用原生打开白条页面
 * @param data  {“url”: } 页面地址 firstPageRouter 首页的路由名称（原生通过此数据判断返回键是否直接返回至产业科技app）
 */
export function openFDWhitePage (data: { url?: string; }) {
  Bridge.callHandler('openFDWhitePage', data)
}

/**
 * js调用原生打开绑定手机号页面
 * @param data  {“path”: 客户选择页面路由名称  “applyType”: 选择客户类型}
 */
export function toBindMobile (data: { path?: string; applyType?: number }) {
  Bridge.callHandler('toBindMobile', data)
}

/**
 * js调用原生api跳转到新页面
 * @param path 新页面h5路由名称
 * @param data 打开新页面需传递的参数，有就传json，无传{}
 */
export function openNewPageFromPath (path: string, data: { [x: string]: any } = {}) {
  const obj = {
    path: path,
    data: data
  }
  Bridge.callHandler('openNewPageFromPath', obj)
}

/**
 * js调用原生方法进行个人信息保护提示弹窗操作
 * @param data  {“type”: } 页面地址 '0'不同意 '1'同意
 */
export function isAgreeConfirm (data: { type?: string; }) {
  Bridge.callHandler('isAgreeConfirm', data)
}


/**
 * js调用原生方法进行用户通讯录选择
 * @ res  {“name”:string;  mobile?: string} name:联系人姓名;mobile:手机号
 */
export function openAddressbook () {
  return new Promise((resolve, reject) => {
    Bridge.callHandler('openAddressbook', {}, (res) => {
      res = !res ? {} : JSON.parse(res)
      resolve(res)
    })
  })
}


/**
 * js调用原生方法导出文件
 * @ data: { method?: string; portUrl: string,params:string } method 接口请求方法名称   portUrl:接口请求地址  params:导出接口请求参数
 */
export function exportFileWithData (data: { method?: string, portUrl?: string; params: any }) {
  return new Promise((resolve, reject) => {
    Bridge.callHandler('exportFileWithData', data, (res) => {
      res = !res ? {} : JSON.parse(res)
      resolve(res)
    })
  })
}

/**
 * js调用原生方法返回首页
 */
export function backHomes () {
  Bridge.callHandler('backHomes')
}

/**
 * @description  访问系统相册,选中图片并进行上传
 * @param {String} filetype 1:图片；2:视频；3:图片视频
 * @param {String} maxFileCount  可以选择的最大文件数量；比如：6,代表最多选择6个文件（图片，视频，图片视频）
 * @returns 图片在服务器的路径 {List}
 */
export function chooseFile(data:{filetype?: string, maxFileCount?:string} = {filetype:'1',maxFileCount:'1'}) {
  return new Promise((resolve, reject) => {
    Bridge.callHandler('chooseFile', data, (res) => {
      res = !res ? {} : JSON.parse(res)
      resolve(res)
    })
  })
}
/*
 * @description: js调用原生方法：修改指定key的value（类似sessionStorage中setItem方法）
 * @param {string} key 键
 * @param {string} value 值
 */
export function setSessionItem (key: string, value: string) {
  Bridge.callHandler('setSessionItem', {
    key,
    value
  })
}

/**
 * @description: js调用原生方法：获取指定key的value（类似sessionStorage中getItem方法）
 * @param {string} key 键
 * @return {*} 指定key的value
 */
export function getSessionItem (key: string) {
  return new Promise((resolve, reject) => {
    Bridge.callHandler('getSessionItem', { key }, (res) => {
      resolve(res)
    })
  })
}

/**
 * 拉起微信小程序，如果拉起微信小程序支付，支付结果状态需要自行查询
 * @param {Object} userName
 * @param {Object} path
 */
export function launchWeixinMiniProgram (data:{userName:string,path:string }) {
  return new Promise((resolve,reject) => {
    Bridge.callHandler('launchWeixinMiniProgram', data,(res) => {
      resolve(res)
    })
  })
}
/**
 * 拉起微信小程序，如果拉起微信小程序支付，支付结果状态需要自行查询
 * @param {Object} userName
 * @param {Object} path
 */
export function launchAliMiniProgram (url?:string ) {
  return new Promise((resolve,reject) => {
    Bridge.callHandler('launchAliMiniProgram', url,(res) => {
      resolve(res)
    })
  })
}

/**
 * 拉起微信或支付宝，切换汇付天下调整
 */
export function launchHuiFuProgram (url?:string ) {
  return new Promise((resolve,reject) => {
    Bridge.callHandler('launchHuiFuProgram', url,(res) => {
      resolve(res)
    })
  })
}

/**
 * 跳转'意见反馈'页面
 */
export function goToFeedback () {
  Bridge.callHandler('goToFeedback', {})
}

/**
 * 跳转'设置'页面
 */
export function goToSet () {
  Bridge.callHandler('goToSet', {})
}

/**
 * @description: 获取本地缓存图片
 * @param {string} url
 * @return {*}
 */
export function setImageWithURL (url: string) {
  return new Promise((resolve, reject) => {
    // 此处用于本地调试展示图片
    if (process.env.NODE_ENV !== 'production') {
      let baseUrl = process.env.VUE_APP_MANAGE_API_BASE_URL

      resolve(`${baseUrl}${url}`)
    }
    Bridge.callHandler('setImageWithURL', {
      'imageUrl': url
    }, (res) => {
      // console.log('res------------', res.slice(0, 50))
      resolve(res)
    })
  })
}

// 获取用户经纬度方法
export function getUserLocationInfo () {
  return new Promise((resolve,reject) => {
    Bridge.callHandler('getUserLocationInfo', {},(res) => {
      res = !res ? {} : JSON.parse(res)
      resolve(res)
    })
  })
}

// 导航到目的地方法
export function goToNavigation (params: any) {
  Bridge.callHandler('goToNavigation', params,(res) => {})
}
